/*
 * @Author: weiyanna weiyanna@jd.com
 * @Date: 2026-06-22 09:53:33
 * @LastEditors: weiyanna weiyanna@jd.com
 * @LastEditTime: 2026-06-22 10:01:38
 * @FilePath: /isp_International/src/util/hooks/checkPermissions.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getUserConfig } from '@/api/newApi/user';
import { runWhenIdle } from '@/util/deferNonCriticalTask';
import React, { createContext, useState, useContext, useEffect } from 'react';

interface UserPermissions {
  [key: string]: any;
}

interface PermissionsContextType {
  permissions: UserPermissions;
  loading: boolean;
  error: Error | null;
  checkPermission: (key: string) => any;
}

export let checkPermission: (key: string) => any;

const PermissionsContext = createContext<PermissionsContextType | undefined>(undefined);

export const PermissionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [permissions, setPermissions] = useState<UserPermissions>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // 注册等公开页无需拉取权限配置（master #329 注册优化意图）
    const pathname = window.location.pathname;
    // 预览页使用 URL token 校验，不读取正式权限配置，避免触发 /jdig/settings/auth。
    const publicPaths = ['/register', '/homepagePreview', '/activityPagePreview'];
    if (publicPaths.includes(pathname)) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchUserSettings = async () => {
      try {
        setLoading(true);
        const response: any = await getUserConfig();
        if (cancelled) {
          return;
        }
        if (response.success) {
          setPermissions(response.value);
        }
        setLoading(false);
      } catch (err) {
        if (cancelled) {
          return;
        }
        setError(err instanceof Error ? err : new Error('An error occurred'));
        setLoading(false);
      }
    };

    // 权限配置非 LCP 关键路径，空闲时再拉，避免与首页 homepage / 鉴权抢连接
    const cancelIdle = runWhenIdle(() => {
      void fetchUserSettings();
    });

    return () => {
      cancelled = true;
      cancelIdle();
    };
  }, []);

  checkPermission = (key: string): boolean => {
    return permissions[key];
  };

  return (
    <PermissionsContext.Provider value={{ permissions, loading, error, checkPermission }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (context === undefined) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }
  return context;
};
